import traqing from '@yola/traqing.js';
import isUserAuthorized from 'src/js/modules/user/verifiers/is-user-authorized';

const track = (eventName, ...props) => {
  if (!eventName || !isUserAuthorized()) return;
  traqing.segment.track(eventName, ...props);
};

export default track;
